
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live-mentorship-terms",
      function () {
        return require("private-next-pages/live-mentorship-terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live-mentorship-terms"])
      });
    }
  